import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postMessageToChannel } from '../../../api/messenger';

import { REQUEST } from '../../../constants/request';

export const sendMessageToChannel = createAsyncThunk(
  'messenger/sendMessageToChannel',
  async (
    { channelUid, chatId, message, type },
    { signal, rejectWithValue },
  ) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = postMessageToChannel(
        { channelUid, chatId, message, type },
        {
          cancelToken: source.token,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.[
          `${arg.userId}/sendMessageToChannel`
        ] || REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const sendMessageToChannelExtraReducers = builder => {
  builder
    .addCase(sendMessageToChannel.pending, (state, { meta }) => {
      const channelUid = meta.arg;
      state.currentLoadings[`${channelUid}/sendMessageToChannel`] =
        REQUEST.pending;
      state.currentRequestIds[`${channelUid}/sendMessageToChannel`] =
        meta.requestId;
    })
    .addCase(sendMessageToChannel.fulfilled, (state, { meta }) => {
      const channelUid = meta.arg;
      state.currentLoadings[`${channelUid}/sendMessageToChannel`] =
        REQUEST.idle;
      state.currentRequestIds[`${channelUid}/sendMessageToChannel`] = undefined;
    })
    .addCase(sendMessageToChannel.rejected, (state, { meta, payload }) => {
      const channelUid = meta.arg;
      state.currentLoadings[`${channelUid}/sendMessageToChannel`] =
        REQUEST.idle;
      state.currentRequestIds[`${channelUid}/sendMessageToChannel`] = undefined;
      state.currentErrors[`${channelUid}/sendMessageToChannel`] = payload;
    });
};
